const ARCGIS_TOKEN = "AAPTa84iU_FH49Ef26KKUvDxiSA..upqWYNKNSCdNaH1w7qYAqac6NfvSnLpwRk5wMdb4P2RXXZzDwgEOjS-52iOagxRVhtj5Ux-h6DdOPWT7lVLHSVignzs_BC24FzlBVFBq1OOMChGz1_ExFQxkFQ2qvtgT_qlA6EjrKQPgcRpcUG8Nw5h_xgMHscnjnmckgB6BfwyZ0qyhAIpVNLUbtixMb4VDr-xBpT7yaPiKOt9TbHqTFLJJE7USFC-hWTAlE4PO5ZCfetUdWunmLA..AT2_37UsPUZ2";

export interface MapStyle {
  id: string;
  name: string;
  labelKey: string;
  url?: string;
  raster?: { tiles: string[]; tileSize: number; attribution?: string };
}

export const MAP_STYLES: MapStyle[] = [
  { id: "basic", name: "Basic", labelKey: "map.styles.basic", url: `https://basemapstyles-api.arcgis.com/arcgis/rest/services/styles/v2/styles/arcgis/streets?token=${ARCGIS_TOKEN}&language=${encodeURIComponent(navigator.language)}&places=attributed` },
  { id: "positron", name: "Light", labelKey: "map.styles.light", url: "https://tuiles.enliberte.fr/styles/positron.json" },
  { id: "dark", name: "Dark", labelKey: "map.styles.dark", url: "https://tuiles.enliberte.fr/styles/dark-matter.json" },
  { id: "fiord", name: "Fiord", labelKey: "map.styles.fiord", url: "https://tuiles.enliberte.fr/styles/fiord-color.json" },
  // { id: "3d", name: "3D", labelKey: "map.styles.3d", url: "https://tuiles.enliberte.fr/styles/maptiler-3d.json" },
  // { id: "toner", name: "Toner", labelKey: "map.styles.toner", url: "https://tuiles.enliberte.fr/styles/toner.json" },
  // { id: "tomtom", name: "TomTom", labelKey: "map.styles.tomtom", url: "https://api.tomtom.com/maps/orbis/assets/styles/0.0.0-0/style?apiVersion=1&key=e8hhk2Sjqq5hK6cdZ32E9fGLFmQCSEAK&map=basic_street-light-driving" },
  {
    id: "osm-raster",
    name: "OpenStreetMap",
    labelKey: "map.styles.osmRaster",
    raster: {
      tiles: ["https://tile.openstreetmap.org/{z}/{x}/{y}.png"],
      tileSize: 256,
      attribution: "© OpenStreetMap contributors"
    }
  },
  {
    id: "google-roadmap",
    name: "Google",
    labelKey: "map.styles.google",
    raster: {
      tiles: ["https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}&scale=2"],
      tileSize: 256,
      attribution: "© Google Maps"
    }
  },
  {
    id: "google-satellite",
    name: "Satellite",
    labelKey: "map.styles.satellite",
    raster: {
      tiles: ["https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}"],
      tileSize: 256,
      attribution: "© Google Maps"
    }
  },
  {
    id: "google-hybrid",
    name: "Hybrid",
    labelKey: "map.styles.hybrid",
    raster: {
      tiles: ["https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}"],
      tileSize: 256,
      attribution: "© Google Maps"
    }
  },
  {
    id: "google-transit",
    name: "Transit",
    labelKey: "map.styles.transit",
    raster: {
      tiles: ["https://mt1.google.com/vt/lyrs=m,traffic&x={x}&y={y}&z={z}"],
      tileSize: 256,
      attribution: "© Google Maps"
    }
  },
  {
    id: "waze",
    name: "Waze",
    labelKey: "map.styles.waze",
    raster: {
      tiles: ["https://www.waze.com/row-tiles/live/base/{z}/{x}/{y}/tile.png?highres=true"],
      tileSize: 256,
      attribution: "© Waze"
    }
  },
];

export function buildRasterStyle(raster: NonNullable<MapStyle["raster"]>) {
  return {
    version: 8 as const,
    sources: {
      "raster-tiles": {
        type: "raster" as const,
        tiles: raster.tiles,
        tileSize: raster.tileSize,
      },
    },
    layers: [{
      id: "raster-layer",
      type: "raster" as const,
      source: "raster-tiles",
      minzoom: 0,
      maxzoom: 22,
    }],
  };
}

export function getStyleSpec(style: MapStyle) {
  return style.raster ? buildRasterStyle(style.raster) : style.url!;
}

export function getSavedStyle(): MapStyle {
  const savedId = localStorage.getItem("mapStyleId");
  return MAP_STYLES.find(s => s.id === savedId) ?? MAP_STYLES[0];
}
